export const BRAND_LOGO_SRC = `${process.env.PUBLIC_URL}/img/salesforce-blue-logo.png`
export const BRAND_LOGO_ALT = "Salesforce"
export const B2T_LOGO_SRC = `${process.env.PUBLIC_URL}/img/b2t_logo.png`
export const B2T_LOGO_ALT = "Bridge2Technologies"
